import {
  Button,
  Select,
  Form,
  Input,
  Popconfirm,
  DatePicker,
  Space,
  Image,
  Col, Row
} from "antd";
import { useNavigate } from "react-router-dom";
import service from "../../services/usersService";
import api from "../../services/usersService";
import React, { useState, useEffect } from "react";
import { getProfile } from "../../security/AppSecurity";
import util from "../../utils/functions/custom";
import { Messages, Notify } from "../../services/custom/Messages";
import {openNotification, ParagraphHeader} from "@seims/shared";
import { recordError } from "../../utils/logService";

export const UserProfile = () => {
  const [user, setUser] = useState([]);

  const [form] = Form.useForm();

  const [userData, setUserData] = useState(getProfile());

  const firstName = userData.firstName;
  const lastName = userData.lastName;
  const emailAddress = userData.emailAddress;

  useEffect(() => {
    form.setFieldsValue({
      firstName: firstName,
      lastName: lastName,
      emailAddress: emailAddress,
    });
  }, []);

  const { Option } = Select;
  const formName = "UserProfile";
  const navigate = useNavigate();
  let path = `/`;

  const formItemLayout = {
    labelCol: {
      xs: {
        span: 12,
      },
      sm: {
        span: 8,
      },
    },
    wrapperCol: {
      xs: {
        span: 12,
      },
      sm: {
        span: 8,
      },
    },
  };

  const onSubmit = async (values) => {
    try {
      const { firstName, lastName } = values;

      const profileValues = {
        firstname: firstName,
        lastname: lastName,
      };
      const request = await api.updateUserProfile(profileValues);

      var msg;

      if (request.status == 200 || request.status == 201) {

        msg = util.parseMessage(
          Messages.UPDATE_SUCCESSWITHOK,
          "Profile info detail(s)"
        );
        openNotification("Updating Profile", msg, Notify.SUCCESS);

        return;
      }

      msg = util.parseMessage(
        Messages.UPDATE_FAILURE,
        "Profile info detail(s)"
      );
      openNotification("Updating Profile", msg, Notify.ERROR);
    } catch (error) {
      // console.log("PROFILE INFO FAILED TO UPDATE", error);
      openNotification(
        "Updating Profile",
        "SYSTEM FAILED TO UPDATE",
        Notify.ERROR
      );
      recordError(error)
    }
  };
  const cancel = () => {
    navigate(path);
  };
  const handleBackClick = () => {
    navigate(path);
  };
  const onFirstnameBlur = (e) => {
    const { value, firstname } = e.target;
    const textValue = util.toPascalText(value);
    form.setFieldsValue({ [firstname]: textValue });
  };

  const onLastnameBlur = (e) => {
    const { value, lastname } = e.target;
    const textValue = util.toPascalText(value);
    form.setFieldsValue({ [lastname]: textValue });
  };

  return (
    <div>
      <Row justify="center" className="page-header" style={{ marginBottom: 10 }}>
        <Col xs={12} md={6} lg={4}>
          <div> 
            <Image
              style={{ textAlign: 'center' }}
              preview={false}
              src={require("../../assets/profile-blue.png")}
              alt="User Profile"
            />
          </div>
        </Col>
      </Row>
      <Row justify="center" style={{ paddingBottom: 30 }} className="public-portal-page user-guides-page">
        <Col lg={20} xs={24} style={{ height: '100%'}}>
          <ParagraphHeader header="User Profile" />
      {/* <Col xs={24}>
        <h1 className="center-align">User Profile</h1>
      </Col> */}
      <Form {...formItemLayout} name={formName} form={form} onFinish={onSubmit}>
        <Form.Item
          disabled
          name="emailAddress"
          label="Username"
          rules={[
            {
              required: true,
              message: "Username may not be empty",
            },
          ]}
        >
          <Input name="emailAddress" disabled />
        </Form.Item>
        <Form.Item
          name="firstName"
          label="First name"
          rules={[
            {
              required: true,
              message: "Firstname may not be empty",
            },
          ]}
        >
          <Input name="firstName" onBlur={onFirstnameBlur} />
        </Form.Item>
        <Form.Item
          name="lastName"
          label="Last name"
          rules={[
            {
              required: true,
              message: "Lastname may not be empty",
            },
          ]}
        >
          <Input name="lastName" onBlur={onLastnameBlur} />
        </Form.Item>
        <Row>
          <Col xs={24} className="center-align">
            <Button key="2" htmlType="submit" shape="round" form={formName} type="primary">
              Update
            </Button>
            {/* <Button key="3" style={{ marginLeft: 10 }} onClick={()=> handleBackClick()}>
              Back
            </Button> */}
            <Popconfirm
              title="Are you sure you want to cancel...you will lose all info entered?"
              onConfirm={cancel}
              okText="Yes"
              cancelText="No"
            >
              <Button type="default" shape="round" style={{ marginLeft: 10 }}>
                Cancel
              </Button>
            </Popconfirm>
          </Col>
        </Row>
      </Form>
      </Col>
      </Row>
    </div>
  );
};
